import request from "./request";
/**
 * 更新标识id
 * @param id 专页id
 * @param flagId 绑定用户名称
 */
export default async function updateFlagId(data) {
  return await request.post("/spin/dataAuthorizationPlayer/updateFlagId", data);
}
